import {get, patch, post, put} from 'utils/axios/index'
import {toast} from 'react-toastify'
import {DefaultApiResponse} from 'models/ApiResponse'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import {IFormField} from 'models/Common'

const fetchSkuSummaryCount = async (
 payload: IFormField
) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/sales/variant-count`, {
   ...payload,
  }).then((res) => {
   if (res) {
    return res.data
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchProductList = async (payload: IFormField) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/product/list`, {
   ...payload,
  }).then((res) => {
   if (res) {
    return res
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchSalesCatalogueList = async (
 payload: IFormField
) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/sales/catalogue`, {
   ...payload,
  }).then((res) => {
   if (res) {
    return res
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const productVariantUpdate = async (
 payload: IFormField
) => {
 try {
  return await (
   await put
  )<DefaultApiResponse>(`/product/variant/update`, {
   ...payload,
  }).then((res) => {
   if (res.success) {
    return res.message
   } else {
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const distributorCatalogueUpdate = async (
 payload: IFormField
) => {
 try {
  return await patch<DefaultApiResponse>(
   `/sales/distributor/catalogue/update`,
   {
    ...payload,
   }
  ).then((res) => {
   if (res.message) {
    return res.message
   } else {
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const productUpsert = async (payload: IFormField) => {
 try {
  return await (
   await post
  )<DefaultApiResponse>(`/product/upsert`, {
   ...payload,
  }).then((res) => {
   if (res.success) {
    return res.message
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchProductConfig = async (
 productCategoryId: string
) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(
   `/product/v1/config/${productCategoryId}`
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchProductDetails = async (payload: IFormField) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/product/get`, payload).then(
   (res) => {
    if (res.success) {
     return res.data
    } else {
     toast.error('Something went wrong')
     return null
    }
   }
  )
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchProductCategory = async () => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/product/business-group`).then(
   (res) => {
    if (res.success) {
     return res.data
    } else {
     toast.error('Something went wrong')
     return null
    }
   }
  )
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

const fetchProductSubCategory = async (
 productCategoryId: string
) => {
 try {
  return await (
   await get
  )<DefaultApiResponse>(`/product/line-of-business`, {
   business_group_id: productCategoryId,
  }).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error('Something went wrong')
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

export {
 fetchSkuSummaryCount,
 fetchProductList,
 productVariantUpdate,
 fetchProductConfig,
 fetchSalesCatalogueList,
 productUpsert,
 fetchProductCategory,
 fetchProductSubCategory,
 fetchProductDetails,
 distributorCatalogueUpdate,
}
